module.exports = __webpack_public_path__ + "static/profile-picture-bc17a0f9fa11c7f7bfe18f81711345bb.jpg";